<template>
    <v-dialog v-model="$store.state.assignment.truckDisabled" width="1200px">
        <v-card>
            <v-toolbar color="secondary" dense>
                <v-spacer></v-spacer>
                <v-toolbar-title class="white--text">{{ header.ShiftDate }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$store.state.assignment.truckDisabled = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container grid-list-xs fluid>
                <v-row>
                    <v-col cols="6">
                        <v-card>
                            <v-toolbar color="secondary" dense>
                                <v-toolbar-title class="white--text">Trucks Actives</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-text-field append-icon="mdi-magnify" dense dark style="width: 80px;"
                                    v-model="search"></v-text-field>
                            </v-toolbar>
                            <v-container grid-list-xs fluid>
                                <v-list style="max-height: 500px;" class="overflow-y-auto">
                                    <v-simple-table style="border-bottom: 1px solid #000; ">
                                        <tr>
                                            <th class="text-left">ID</th>
                                            <th class="text-left">Truck</th>
                                        </tr>
                                    </v-simple-table>
                                    <draggable v-model="filteredTruck" group="Truck" style="max-height: 500px"
                                        ghost-class="ghost" :search="search" :move="checkMove" dense>
                                        <template v-for="shift in filteredTruck">
                                            <v-list-item dense v-bind:key="shift.id" style="border-bottom: 1px solid #000;">
                                                <div class="shifts5">
                                                    {{ shift.TruckID }}
                                                </div>

                                                <div class="shifts5">
                                                    {{ shift.Truck }}
                                                </div>
                                            </v-list-item>
                                        </template>
                                    </draggable>
                                </v-list>
                            </v-container>
                        </v-card>
                    </v-col>

                    <v-col cols="6">
                        <v-card>
                            <v-toolbar color="secondary" dense>
                                <v-toolbar-title class="white--text">Trucks Disbaled</v-toolbar-title>
                                <v-spacer></v-spacer><v-btn color="success" class="float-left" @click="exportExcel"
                                    icon><v-icon>mdi-microsoft-excel</v-icon></v-btn>
                                <v-icon dark @click="loadTruckIdle">mdi-refresh</v-icon>
                            </v-toolbar>
                            <v-container grid-list-xs fluid>
                                <v-simple-table style="border-bottom: 1px solid #000;">
                                    <tr>
                                        <th>ID</th>
                                        <th>Truck</th>
                                        <th>Options</th>
                                    </tr>
                                </v-simple-table>
                                <v-list v-if="!spiner">
                                    <draggable v-model="trucksDisabled" ghost-class="ghost" group="Truck" @add="addTruck"
                                        style="min-height: 500px;border-bottom: 1px solid #000;" dense>
                                        <template v-for="(truck, index) in trucksDisabled">
                                            <v-list-item dense v-bind:key="truck.TruckID"
                                                style="border-bottom: 1px solid #000;">
                                                <div class="shifts5">
                                                    {{ truck.TruckID }}
                                                </div>
                                                <div class="shifts5">
                                                    {{ truck.Truck }}
                                                </div>
                                                <div class="text-center" style="width: 60%;">
                                                    <v-icon color="success" class="ml-2" @click="openComment(truck, 1, index)"
                                                        v-if="truck.rgb != null">mdi-content-save</v-icon>
                                                    <v-icon color="primary" class="ml-2" @click="openComment(truck, 2, index)"
                                                        v-if="truck.rgb == null">mdi-file-edit</v-icon>
                                                    <v-icon color="red" class="ml-2" @click="deleteTruckIdle(truck, index)"
                                                        v-if="truck.rgb == null">mdi-delete</v-icon>
                                                </div>
                                            </v-list-item>
                                        </template>
                                    </draggable>
                                </v-list>
                                <v-row v-else justify="center" class="mt-5 mb-5">
                                    <div class="sk-chase">
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                        <div class="sk-chase-dot"></div>
                                    </div>
                                </v-row>
                            </v-container>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="400px" transition="dialog-transition">
            <v-card>
                <v-toolbar color="secondary" dense>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">Comment</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="closeModal">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-container grid-list-xs fluid>

                    <v-row justify="end">
                        <v-col cols="12">
                            <v-textarea label="Comments" hide-details rows="5" v-model="Comment"></v-textarea>
                        </v-col>
                        <v-btn color="primary" class="mr-5 mb-2" @click="save">Save</v-btn>
                    </v-row>
                </v-container>
            </v-card>
        </v-dialog>
    </v-dialog>
</template>
<script>
import draggable from 'vuedraggable';
import axios from 'axios';
export default {
    props: ['data', 'header'],
    components: {
        draggable,
    },
    data: function () {
        return {
            truckOrigin: [],
            params: {},
            trucks: [],
            spiner: false,
            UpdateIdx: 0,
            Comment: '',
            search: '',
            dialog: false,
            truck: [],
            closeIdx: null,
            from: 0,
            trucksDisabled: []
        };
    },

    computed: {
        filteredTruck() {
            var textSearch = this.search;
            return this.trucks.filter(function (el) {
                return el.Truck.toLowerCase().indexOf(textSearch.toLowerCase()) !== -1;
            });
            
        }
    },
    mounted() {
        console.log(this.header);
        this.loadTrucks();
    },
    methods: {
        reloadTrucks: function () {
            console.log(this.trucks, this.truckOrigin);
        },
        deleteTruckIdle: function (truck, idx) {
            console.log(truck, idx)
            this.spiner = true;
            var str = this.$store;
            axios
                .delete('/truck-idle/destroy/' + truck.idCause, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(async response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Delete success!!'
                    });
                    this.spiner = false;
                    const size = this.trucks.length;
                    this.trucks[size] = this.trucksDisabled[idx];
                    this.trucksDisabled.splice(idx, 1);
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        loadTruckIdle: function () {
            var str = this.$store;
            this.spiner = true;
            var parms = {
                Export: 0,
                Shift: this.header.ShiftId,
            };
            axios
                .post('/truck-idle/shift',parms, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.trucksDisabled = response.data;
                    this.filterTruckIdle();
                    this.spiner = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        filterTruck: async function () {
            await this.data.forEach((elm) => {
                var idx = this.trucks.findIndex(x => {
                    return x.Truck == elm.Truck;
                })
                this.trucks.splice(idx, 1);
            });
            await this.trucks.forEach(elm => {
                elm.rgb = null;
            });
            console.log(this.trucks);
        },
        filterTruckIdle: async function () {
            await this.trucksDisabled.forEach((elm) => {
                var idx = this.trucks.findIndex(x => {
                    return x.Truck == elm.Truck;
                })
                this.trucks.splice(idx, 1);
            });
            await this.trucks.forEach(elm => {
                elm.rgb = null;
            });
            console.log(this.trucks);
        },
        loadTrucks: function () {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .get('truck/active', {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    this.trucks = response.data;
                    this.loadTruckIdle();
                    str.state.isLoading = false;
                    this.filterTruck();
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        checkMove: function (evt) {
            return (evt);
        },
        closeModal: function () {
            this.dialog = false;
        },
        addTruck: function (evt) {

            this.closeIdx = null;
            this.Comment = '';
            this.params.length = 0;
            // const idx = this.trucks.findIndex(x=>{
            //     return x.TruckID == this.trucksDisabled[evt.newIndex].TruckID;
            // });
            // this.trucks.splice(idx, 1);
            if (evt.from != evt.to) {
                this.params = {
                    Truck: this.trucksDisabled[evt.newIndex].TruckID,
                    ShiftHeader: this.header.ShiftId,
                    Comment: null
                }

                this.trucksDisabled[evt.newIndex].rgb = '#ffffdb';
                this.closeIdx = evt.newIndex;
                this.from = 0;
                this.dialog = true;
            }
        },
        async save() {
            this.dialog = false;
            this.spiner = true;
            if (this.from == 0) {
             await   this.saveTruckIdle();
                    this.loadTrucks();
            } else if (this.from == 1) {
              await  this.saveAfter(this.edit);
                    this.loadTrucks();
            } else {
                this.updateTruckIdle(this.edit);
            }
        },
        updateTruckIdle: function (truck) {
            var params = {
                Comment: this.Comment,
            }
            var str = this.$store;
            console.log(params);
            axios
                .put('truck-idle/update/' + truck.idCause, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Update comment success!!'
                    });
                    this.trucksDisabled[this.UpdateIdx].Comment = response.data.Comment;
                    this.spiner = false;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        openComment: function (truck, stt, idx) {
            this.from = stt;
            this.Comment = truck.Comment;
            this.UpdateIdx = idx;
            this.dialog = true;
            this.edit = truck;
        },
        saveAfter: function (truck) {
            var str = this.$store;
            var params = {
                Truck: truck.TruckID,
                ShiftHeader: this.header.ShiftId,
                Comment: this.Comment
            }
            axios
                .post('truck-idle', params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save success !!'
                    });
                    this.spiner = false;
                    this.trucksDisabled[this.closeIdx].rgb = null;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        exportExcel: function () {
            var parms = {
                Export: 1,
                Shift: this.header.ShiftId,
            };
            var str = this.$store;
            str.state.isLoading = true;
            axios
                .post('/truck-idle/shift',parms, {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Trucks Disbaled.xlsx');
                    document.body.appendChild(link);
                    link.click();

                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        saveTruckIdle: function () {
            this.params.Comment = this.Comment;
            var str = this.$store;
            console.log(this.params);
            axios
                .post('truck-idle', this.params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    }
                })
                .then(response => {
                    console.log(response.data);

                    this.spiner = false;
                    str.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'Save success !!'
                    });
                    this.trucksDisabled[this.closeIdx].Comment = response.data.Comment;
                    this.trucksDisabled[this.closeIdx].idCause = response.data.idCause;
                    this.trucksDisabled[this.closeIdx].rgb = null;
                    str.state.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    str.state.isLoading = false;
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        }
    }
};
</script>
<style>
.orderText {
    font-size: 10.5px;
    border-bottom: 1px solid lightgrey;
}

div.shifts5 {
    width: 20%;
}

.spinner {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}

.sk-chase {
    width: 40px;
    height: 40px;
    position: relative;
    animation: sk-chase 2.5s infinite linear both;
}

.sk-chase-dot {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    animation: sk-chase-dot 2s infinite ease-in-out both;
}

.sk-chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #4f83cc;
    border-radius: 100%;
    animation: sk-chase-dot-before 2s infinite ease-in-out both;
}

.sk-chase-dot:nth-child(1) {
    animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2) {
    animation-delay: -1s;
}

.sk-chase-dot:nth-child(3) {
    animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4) {
    animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5) {
    animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6) {
    animation-delay: -0.6s;
}

.sk-chase-dot:nth-child(1):before {
    animation-delay: -1.1s;
}

.sk-chase-dot:nth-child(2):before {
    animation-delay: -1s;
}

.sk-chase-dot:nth-child(3):before {
    animation-delay: -0.9s;
}

.sk-chase-dot:nth-child(4):before {
    animation-delay: -0.8s;
}

.sk-chase-dot:nth-child(5):before {
    animation-delay: -0.7s;
}

.sk-chase-dot:nth-child(6):before {
    animation-delay: -0.6s;
}

@keyframes sk-chase {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot {

    80%,
    100% {
        transform: rotate(360deg);
    }
}

@keyframes sk-chase-dot-before {
    50% {
        transform: scale(0.4);
    }

    100%,
    0% {
        transform: scale(1);
    }
}
</style>
